<template>
  <div
    class="position-relative"
    @click="toggleDropdown"
    @blur="closeDropdown"
    tabindex="0"
    :class="{ 'disabled': disabled }"
  >
    <!-- Selected Option Display -->
    <div class="form-control d-flex justify-content-between align-items-center cursor-pointer bg-white" style="height: fit-content;">
      <p class="mb-0 fw-bold">{{ selectedOption?.label || "-- Select option --" }}</p>
      <i class="fa fa-chevron-down"></i>
    </div>

    <!-- Dropdown Menu -->
    <div
      v-if="isOpen"
      class="position-absolute zindex-dropdown mt-1 w-100 bg-white border rounded shadow-sm"
      style="max-height: 250px; overflow-y: auto;"
    >
      <div
        v-for="option in options"
        :key="option.value"
        @click.stop="selectOption(option)"
        class="px-3 py-2 cursor-pointer hover-bg-light"
      >
        <p class="mb-0 fw-medium">{{ option.label }}</p>
        <small class="text-muted">{{ option.description }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "customSelect",
    props: {
        value: [String, Number, Object],
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        selectedOption() {
            return this.options.find((opt) => opt.value === this.value);
        },
    },
    methods: {
        toggleDropdown() {
            if (this.disabled) return;
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        selectOption(option) {
            this.$emit("input", option.value);
            this.isOpen = false;
        },
    },
};
</script>

<style scoped>
/* Optional: add transitions or styling here */
.hover-bg-light:hover {
  background-color: #f8f9fa; /* Bootstrap's light color */
}

.cursor-pointer {
  cursor: pointer;
}

.zindex-dropdown {
  z-index: 1050; /* Bootstrap dropdown z-index */
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
